/**
 * @generated SignedSource<<35e054261115f8a046cb8bdfd6a0512a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePermissionsFragment$data = {
  readonly __typename: "AssignmentSubmission";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nonNullProductId: string;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "BrainSearch";
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "ChatChannel";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nullableProductId: string | null;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "Comment";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nullableProductId: string | null;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "ContentUsage";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nullableProductIdString: string | null;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "Dashboard";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nullableProductId: string | null;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "Event";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nonNullProductId: string;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "Feed";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nullableProductId: string | null;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "Organization";
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "PathwayGroup";
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "Post";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nullableProductId: string | null;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  readonly __typename: "Product";
  readonly memberPermissions: ReadonlyArray<string>;
  readonly nonNullProductId: string;
  readonly viewerPermissions: ReadonlyArray<string>;
  readonly " $fragmentType": "usePermissionsFragment";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "usePermissionsFragment";
};
export type usePermissionsFragment$key = {
  readonly " $data"?: usePermissionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v3 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v0/*: any*/),
  (v2/*: any*/)
],
v4 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v0/*: any*/),
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePermissionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v4/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v4/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v4/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v4/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v4/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "c4f212a6a3ff1f2435d434508a92184e";

export default node;
